import { Box, Button, Dialog, DialogContent, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import WinPrizeBtn from '../../assets/WinPrizeBtn.png';
import backBtn from '../../assets/btnBack.png';

const PrizeDetail = () => {
  const [open, setopen] = useState(false);
  const location = useLocation();
  const { item } = location.state || {};
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-container': {
      backdropFilter: 'blur(7px)'
    },
    '& .MuiDialog-paper': {
      borderRadius: theme.breakpoints.up('sm') ? '20px' : '18px',
      backdropFilter: 'blur(7px)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
      width: useMediaQuery(theme.breakpoints.down('sm')) ? '85%' : '60%',
      maxWidth: 'none',
      height: useMediaQuery(theme.breakpoints.down('sm')) ? '87%' : '80%',
      backgroundColor: 'transparent'
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      color: 'none'
    }
  }));

  useEffect(() => {
    if (item) {
      setopen(true);
    }
  }, []);

  const handleWinPrizes = () => {
    navigate('/quests');
    setopen(false);
  };

  const handleBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div>
      <BootstrapDialog open={open} maxWidth="md" fullWidth scroll="body">
        <DialogContent
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            height: '100%',
            scrollbarWidth: 'none',
            padding: '16px',
            background: 'white'
          }}>
          <Box
            style={{
              height: '50%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <img
              src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/PrizeAvatars/${item?.avatar}`}
              alt={'prize'}
              style={{ height: '100%' }}></img>
          </Box>
          <Button
            onClick={handleBackClick}
            style={{
              position: 'absolute',
              top: 16,
              left: 16,
              zIndex: 2,
              cursor: 'pointer',

              color: 'black'
            }}>
            <img
              src={backBtn}
              alt="backBtn"
              style={{
                width: isMobile ? 24 : 32,
                height: isMobile ? 24 : 32
              }}></img>
          </Button>
          <Typography
            sx={{
              mt: 1,
              color: '#666',
              padding: isMobile ? '0 0 0 15px' : '0 14px 0 30px',
              fontFamily: 'Baloo2',
              fontSize: isMobile ? '24px' : '48px',
              whiteSpace: 'pre-line',
              fontWeight: 800
            }}>
            {item.name}
          </Typography>
          <Typography
            sx={{
              mt: 1,
              color: '#666',
              padding: isMobile ? '0 0 0 15px' : '0 14px 0 30px',
              fontFamily: 'Baloo2',
              fontSize: isMobile ? '12px' : '14.7px',
              whiteSpace: 'pre-line'
            }}>
            {item.desc}
          </Typography>

          <Button style={{ position: 'absolute', bottom: '3px', cursor: 'pointer' }} onClick={handleWinPrizes}>
            <img src={WinPrizeBtn} alt={'btn'}></img>
          </Button>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};
export default PrizeDetail;
